import ta from 'technicalindicators'

export class ChartingSystem {
  public transform(rawData: any): ta.CandleList {
    return rawData
  }
}